import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.13.1_@types+node@18.19.71_eslint@8.57.1_less@4.2.2_typescript@5.7.3_vite@5.4.13/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}